import { cn } from "~/lib/utils";

/** How much of a source is in the index, as counts, a bar and a percentage. */
export const CoverageMeter = ({ indexed, inSource }: { indexed: number; inSource: number }) => {
  // No denominator, and an invented rate would read as a finding.
  if (inSource === 0) {
    return <span className="text-xs text-muted-foreground">Not compared</span>;
  }
  // Orphans can put more in the index than the source; the Orphaned column reports that.
  const percent = Math.min(100, Math.round((indexed / inSource) * 100));

  return (
    <div className="flex items-center justify-end gap-2">
      <span className="text-xs tabular-nums text-muted-foreground">
        {indexed}/{inSource}
      </span>
      <div
        role="meter"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Indexed share of the source"
        className={cn(
          "h-1.5 w-16 shrink-0 overflow-hidden rounded-full",
          // The fill's own ramp, so a low rate reads as unindexed rather than empty.
          percent >= 90 ? "bg-green-200" : percent >= 50 ? "bg-orange-200" : "bg-red-200"
        )}
      >
        <div
          className={cn(
            "h-full rounded-full",
            percent >= 90 ? "bg-green-500" : percent >= 50 ? "bg-orange-500" : "bg-red-500"
          )}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className="w-8 text-right text-xs tabular-nums text-foreground">{percent}%</span>
    </div>
  );
};
